<script setup lang="ts">
</script>

<template>
  <client-only>
    <v-app id="app">
      <ErrorBoundary>
        <NuxtLayout>
          <NuxtPage />
        </NuxtLayout>
      </ErrorBoundary>
      <app-snackbar />
    </v-app>
  </client-only>
</template>

<style lang="scss">
:root {
  --page-max-width: min(2000px, calc(100vw - 16px));
}

.v-container {
  max-width: var(--page-max-width);
}

#app {
  background: #f9f9f9;
}
@font-face {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-display: auto;
  src:
    url("/fonts/Monserrat/Montserrat-700.woff2") format("woff2"),
    url("/fonts/Monserrat/Montserrat-700.woff") format("woff");
}

@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 500;
  font-display: auto;
  src:
    url("/fonts/OpenSans/OpenSans-500.woff2") format("woff2"),
    url("/fonts/OpenSans/OpenSans-500.woff") format("woff");
}

@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-display: auto;
  src:
    url("/fonts/OpenSans/OpenSans-600.woff2") format("woff2"),
    url("/fonts/OpenSans/OpenSans-600.woff") format("woff");
}

@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-display: auto;
  src:
    url("/fonts/OpenSans/OpenSans-700.woff2") format("woff2"),
    url("/fonts/OpenSans/OpenSans-700.woff") format("woff");
}

@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url("/fonts/Roboto/Roboto-400.woff2") format("woff2"), url("/fonts/Roboto/Roboto-400.woff") format("woff");
}

@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url("/fonts/Roboto/Roboto-500.woff2") format("woff2"), url("/fonts/Roboto/Roboto-500.woff") format("woff");
}
</style>
